/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InventoryCountingDetModel { 
    inventoryCountingDetId?: number;
    inventoryCountingId?: number;
    ordinal?: number;
    itemNumber?: string | null;
    uOfM?: string | null;
    quantity?: number;
    reference?: string | null;
    countInventoryType?: number;
    timeStamp?: string;
    statusId?: number;
    itemDescription?: string | null;
    readonly countInventoryTypeDisplay?: string | null;
}

